import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux"
import { DOCUMENT_TYPE_PATH } from "../../../../config/paths";
import { postDocumentType } from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from "../../../layout/Content";
import DocumentTypeForm from "./DocumentTypeForm";

export const NewDocumentType = ({ breadcrumbs, dispatchPostDocumentType }) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    dispatchPostDocumentType(newFormValues);
  };

  const content = (
    <DocumentTypeForm
      onSubmit={onSubmit}
      initialValues={{}}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Tipo de Documento"
      subtitle="Crear nuevo tipo de documento"
      content={content}
    />
  );
};

NewDocumentType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDocumentType: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostDocumentType: postDocumentType,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Documento',
      href: DOCUMENT_TYPE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewDocumentType)